module.exports = __webpack_public_path__ + "img/2.741ed3b9.jpg";